// Link targets for the landing home shell.
// In-app routes use react-router paths; marketing-only pages (About / Privacy /
// Terms) live on the marketing site, so they point to the absolute domain.
export const MARKETING_SITE = 'https://cricfight.in';

export const links = {
  // In-app routes (react-router)
  home: '/',
  login: '/login',
  register: '/register',
  startMatch: '/scorecard/start-match',
  contact: '/contact',
  // Marketing-only pages
  about: `${MARKETING_SITE}/about`,
  privacy: `${MARKETING_SITE}/privacy-policy`,
  terms: `${MARKETING_SITE}/terms`,
};
